// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

interface ProductAvgPriceType {
  avg_price_use: number
}

export function useProductAvgPrice(product_id: string): {
  avg_price: ProductAvgPriceType
  isLoadingAvg: boolean
} {
  const api = useApi()
  const [avg_price, setAvgPrice] = useState<ProductAvgPriceType>({ avg_price_use: 0 })
  const [isLoadingAvg, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)

    api
      .get("/product/avg_price_use", { params: { product_id } })
      .then((res: SuccessFetch<{ payload: ProductAvgPriceType }>) => {
        setAvgPrice({ avg_price_use: res.data.payload.avg_price_use })
      })
      .catch(() => {
        setAvgPrice({ avg_price_use: 0 })
      })
      .finally(() => {
        setLoading(false)
      })

    // eslint-disable-next-line
  }, [product_id])

  return { avg_price, isLoadingAvg }
}